import React from 'react';

import { useTranslation } from 'react-i18next';

import { formatTo6Decimals } from '@/utils';

import BalanceCom from './BalanceCom';
import LpTokenImg from './LpTokenImg';
import PresentData from './PresentData';

const LpProportion = ({ children, tokenA, tokenB, myLpInfo, balanceLp, balanceLpLod, loading, type = true }: {
    children?: React.ReactNode,
    tokenA: {
        symbol: string,
        logo: string,

    }, tokenB: {
        symbol: string,
        logo: string,

    }, myLpInfo: {
        shareBf: string,
        token0Amount: string,
        token1Amount: string,
    },
    balanceLp: bigint,
    balanceLpLod: boolean,
    loading: boolean,
    type?: boolean,
}) => {
    const { t } = useTranslation()
    return (
        <div className='bg-white rounded-5 p-3.75 text-mainBlack text-sm border border-ee'>
            <div className='flex items-center justify-between mb-5'>
                <div className='flex items-center'>
                    <div className='mr-5.5'><LpTokenImg className='w-6' fromTokenLogo={tokenA.logo} toTokenLogo={tokenB.logo} /></div>
                    {tokenA.symbol} / {tokenB.symbol}
                </div>
                <BalanceCom balance={balanceLp} loading={balanceLpLod} />
            </div>
            <div className='flex items-center justify-between mb-2.5'>
                <div className='flex items-center'>
                    <img className='w-6.25 mr-2.5' src={tokenA.logo} alt="" />
                    {tokenA.symbol}
                </div>
                <PresentData value={formatTo6Decimals(myLpInfo.token0Amount as string)} loading={loading} />
            </div>
            <div className={`flex items-center justify-between ${type ? 'mb-2.5' : ''} `}>
                <div className='flex items-center'>
                    <img className='w-6.25 mr-2.5' src={tokenB.logo} alt="" />
                    {tokenB.symbol}
                </div>
                <PresentData value={formatTo6Decimals(myLpInfo.token1Amount as string)} loading={loading} />
            </div>
            {type && <div className='flex items-center justify-between mb-2.5'>
                <div>{t('com.yourPoolShare')}:</div>
                <PresentData text='%' value={formatTo6Decimals(myLpInfo.shareBf as string)} loading={loading} />
            </div>}
            {
                children && children
            }
        </div>
    )
}

export default LpProportion